<template>
	<nav class="tabBar" aria-label="底部导航">
		<ul>
			<li :class="{ trip: checks === 0 }">
				<NuxtLink class="tabBar-link" :to="getJumpUrl(0)">
					<i class="iconfont" :class="checks === 0 ? 'icon-v2shouye-a' : 'icon-v2shouye-b'" aria-hidden="true"></i>
					<span class="title">首页</span>
				</NuxtLink>
			</li>

			<li :class="{ trip: checks === 1 }">
				<NuxtLink class="tabBar-link" :to="getJumpUrl(1)">
					<i class="iconfont" :class="checks === 1 ? 'icon-v2fenlei-a' : 'icon-v2fenlei-b'" aria-hidden="true"></i>
					<span class="title">分类</span>
				</NuxtLink>
			</li>

			<li :class="{ trip: checks === 2 }">
				<NuxtLink class="tabBar-link" :to="getJumpUrl(2)">
					<i class="iconfont" :class="checks === 2 ? 'icon-v2zhandian-a' : 'icon-v2zhandian-b'" aria-hidden="true"></i>
					<span class="title">站点</span>
				</NuxtLink>
			</li>

			<li :class="['buyCarBox', { trip: checks === 3 }]">
				<NuxtLink class="tabBar-link" :to="getJumpUrl(3)" rel="nofollow" @click="handleCartClick">
					<i class="iconfont" :class="checks === 3 ? 'icon-v2gouwuche-a' : 'icon-v2gouwuche-b'" aria-hidden="true"></i>
					<span class="title">购物车</span>
					<span v-if="cartCount > 0" class="corner">
						{{ cartCount }}
					</span>
				</NuxtLink>
			</li>

			<li :class="{ trip: checks === 4 }">
				<NuxtLink class="tabBar-link" :to="getJumpUrl(4)" rel="nofollow">
					<i class="iconfont" :class="checks === 4 ? 'icon-v2wode-a' : 'icon-v2wode-b'" aria-hidden="true"></i>
					<span class="title">我的</span>
				</NuxtLink>
			</li>
		</ul>
	</nav>
</template>

<script setup>
import { computed } from 'vue';
import { useCartStore } from '@/stores/cart';
import { checkMerchantStatus } from '@/utils/checkMerchantStatus';

const props = defineProps({
	checks: {
		type: Number,
		default: 0,
	},
});

const cartStore = useCartStore();
const cartCount = computed(() => cartStore.cartCount || 0);

const urls = ['/', '/c', '/company', '/buyCar', '/my'];
const getJumpUrl = index => {
	return urls[index];
};

const handleCartClick = event => {
	const needJump = checkMerchantStatus();
	if (needJump) {
		event?.preventDefault();
	}
};
</script>

<style scoped lang="scss">
.tabBar {
	width: 100%;
	min-height: 50px;
	background-color: #fff;
	z-index: 111111111;
	position: fixed;
	bottom: 0;
	left: 0;
	box-shadow: 0px -2px 10px 0px rgba(99, 118, 159, 0.15);
	padding-bottom: env(safe-area-inset-bottom);

	ul {
		display: flex;
		justify-content: space-around;
		align-items: center;
		height: 100%;
		margin: 0;
		padding: 0;
		list-style: none;

		li {
			height: 100%;
			flex: 1;
			font-size: 10px;
			font-family: NotoSansSC-Regular, NotoSansSC;
			text-align: center;
			font-weight: 400;
			color: #595959;
			cursor: pointer;

			.tabBar-link {
				height: 100%;
				padding-top: 6px;
				display: flex;
				flex-direction: column;
				align-items: center;
				color: inherit;
				text-decoration: none;
			}

			.iconfont {
				width: 24px;
				height: 24px;
				margin: 0 auto;
				font-size: 20px;
			}

			.title {
				height: 14px;
				line-height: 14px;
				margin-top: 2px;
			}
		}
	}

	.trip {
		color: #455bd9;
	}

	.buyCarBox {
		position: relative;

		.corner {
			position: absolute;
			top: 0.3rem;
			right: 1.25rem;
			min-width: 1.35rem;
			padding: 0.1rem;
			background: #e02323;
			border-radius: 0.6rem;
			border: 0.08rem solid #ffffff;
			font-size: 0.83rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #ffffff;
			line-height: 1rem;
			text-align: center;
		}
	}
}
</style>
